import { BsEye } from 'react-icons/bs';
import { Button } from '@/core/ui';
import { useContentReview } from '@/store';

export type ReasonCellProps = {
  reviewId: string;
  reasonText: string;
  lineClamp?: 4 | 5;
  buttonVariant?: 'light' | 'solid';
  buttonColor?: 'default' | 'secondary';
  iconClassName?: string;
};

const LINE_CLAMP_CLASS = {
  4: 'line-clamp-4',
  5: 'line-clamp-5',
} as const;

export const ReasonCell: React.FC<ReasonCellProps> = ({
  reviewId,
  reasonText,
  lineClamp = 5,
  buttonVariant = 'light',
  buttonColor = 'default',
  iconClassName = 'text-default-500',
}) => {
  const openFeedbackModal = useContentReview.use.openFeedbackModal();
  const displayText = reasonText || '---';

  return (
    <div className='relative bg-content1 rounded-lg p-2 border border-default-200'>
      <pre
        className={`text-sm wrap-break-word font-mono text-default-800 whitespace-pre-wrap ${LINE_CLAMP_CLASS[lineClamp]}`}
      >
        {displayText}
      </pre>
      <Button
        isIconOnly
        size='sm'
        variant={buttonVariant}
        color={buttonColor}
        radius={buttonVariant === 'solid' ? 'sm' : undefined}
        className='min-w-6 w-6 h-6 absolute top-2 right-2'
        onPress={() => openFeedbackModal(reviewId, reasonText, 'reason')}
        aria-label='View reason details'
      >
        <BsEye className={`size-3.5 ${iconClassName}`} />
      </Button>
    </div>
  );
};
